<template>
    <table class="w-100 mt-3 table-border-thick table" style="border-width: 3px;">
        <tbody>
            <tr>
                <td>
                    <h3>{{ $t('report.byShifts') }}</h3>
                    <table class="w-100 table-sm table-borderless" v-for="shift in report.shifts" :key="shift.shift_number">
                        <tbody>
                            <tr>
                                <th>{{ $t('report.shift') }} {{ shift.shift_number }}</th>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">
                                    {{ shift.operations.sell.count }}
                                </td>
                                <td class="align-top flex-grow-1">
                                    {{ $t(`report.sell`) }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ shift.operations.sell.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">
                                    {{ shift.operations.buy.count }}
                                </td>
                                <td class="align-top flex-grow-1">
                                    {{ $t(`report.buy`) }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ shift.operations.buy.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">
                                    {{ shift.operations.sell_return.count }}
                                </td>
                                <td class="align-top flex-grow-1">
                                    {{ $t(`report.sellReturn`) }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ shift.operations.sell_return.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">
                                    {{ shift.operations.buy_return.count }}
                                </td>
                                <td class="align-top flex-grow-1">
                                    {{ $t(`report.buyReturn`) }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ shift.operations.buy_return.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t(`report.deposit`) }}</td>
                                <td align="right" colspan="3"></td>
                            </tr>
                            <tr>
                                <td>{{ shift.money_placements.deposit.operations_count }}</td>
                                <td align="right" colspan="3">{{ shift.money_placements.deposit.operations_sum }}&nbsp;&#8376;</td>
                            </tr>
                            <tr>
                                <td>{{ $t(`report.withdrawal`) }}</td>
                                <td align="right" colspan="3"></td>
                            </tr>
                            <tr>
                                <td>{{ shift.money_placements.withdrawal.operations_count }}</td>
                                <td align="right" colspan="3">{{ shift.money_placements.withdrawal.operations_sum }}&nbsp;&#8376;</td>
                            </tr>
                            <tr v-if="isV2">
                                <td colspan="3">{{ $t('report.discounts') }}</td>
                            </tr>
                            <tr v-if="isV2">
                                <td class="align-top flex-grow-1" style="width:20%;">
                                    {{ shift.discounts.buy.count }}
                                </td>
                                <td class="align-top flex-grow-1">
                                    {{ $t(`report.buy`) }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ shift.discounts.buy.sum }} &nbsp;&#8376;
                                </td>
                            </tr>
                            <tr v-if="isV2">
                                <td class="align-top flex-grow-1" style="width:20%;">
                                    {{ shift.discounts.sell.count }}
                                </td>
                                <td class="align-top flex-grow-1">
                                    {{ $t(`report.sell`) }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ shift.discounts.sell.sum }} &nbsp;&#8376;
                                </td>
                            </tr>
                            <tr v-if="isV2">
                                <td class="align-top flex-grow-1" style="width:20%;">
                                    {{ shift.discounts.buy_return.count }}
                                </td>
                                <td class="align-top flex-grow-1">
                                    {{ $t(`report.buyReturn`) }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ shift.discounts.buy_return.sum }} &nbsp;&#8376;
                                </td>
                            </tr>
                            <tr v-if="isV2">
                                <td class="align-top flex-grow-1" style="width:20%;">
                                    {{ shift.discounts.sell_return.count }}
                                </td>
                                <td class="align-top flex-grow-1">
                                    {{ $t(`report.sellReturn`) }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ shift.discounts.sell_return.sum }} &nbsp;&#8376;
                                </td>
                            </tr>
                            
                            <tr v-if="isV2">
                                <td colspan="3">{{ $t('report.markups') }}</td>
                            </tr>
                            <tr v-if="isV2">
                                <td class="align-top flex-grow-1" style="width:20%;">
                                    {{ shift.markups.buy.count }}
                                </td>
                                <td class="align-top flex-grow-1">
                                    {{ $t(`report.buy`) }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ shift.markups.buy.sum }} &nbsp;&#8376;
                                </td>
                            </tr>
                            <tr v-if="isV2">
                                <td class="align-top flex-grow-1" style="width:20%;">
                                    {{ shift.markups.sell.count }}
                                </td>
                                <td class="align-top flex-grow-1">
                                    {{ $t(`report.sell`) }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ shift.markups.sell.sum }} &nbsp;&#8376;
                                </td>
                            </tr>
                            <tr v-if="isV2">
                                <td class="align-top flex-grow-1" style="width:20%;">
                                    {{ shift.markups.buy_return.count }}
                                </td>
                                <td class="align-top flex-grow-1">
                                    {{ $t(`report.buyReturn`) }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ shift.markups.buy_return.sum }} &nbsp;&#8376;
                                </td>
                            </tr>
                            <tr v-if="isV2">
                                <td class="align-top flex-grow-1" style="width:20%;">
                                    {{ shift.markups.sell_return.count }}
                                </td>
                                <td class="align-top flex-grow-1">
                                    {{ $t(`report.sellReturn`) }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ shift.markups.sell_return.sum }} &nbsp;&#8376;
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </td>                
            </tr>
            <tr v-if="isV2">
                <td>
                    <table class="w-100 table-sm table-borderless">
                        <tbody>
                            <tr>
                                <td>
                                    <table class="w-100 table-sm table-borderless">
                                        <tbody>
                                            <tr>
                                                <td colspan="3"><h4>{{ $t('report.summaryDiscounts') }}</h4></td>
                                            </tr>
                                            <tr>
                                                <td class="align-top flex-grow-1" style="width:20%;">
                                                    {{ report.summary_discounts.buy.count }}
                                                </td>
                                                <td class="align-top flex-grow-1">
                                                    {{ $t(`report.buy`) }}
                                                </td>
                                                <td class="flex-shrink-1" align="right">
                                                    {{ report.summary_discounts.buy.sum }} &nbsp;&#8376;
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top flex-grow-1" style="width:20%;">
                                                    {{ report.summary_discounts.sell.count }}
                                                </td>
                                                <td class="align-top flex-grow-1">
                                                    {{ $t(`report.sell`) }}
                                                </td>
                                                <td class="flex-shrink-1" align="right">
                                                    {{ report.summary_discounts.sell.sum }} &nbsp;&#8376;
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top flex-grow-1" style="width:20%;">
                                                    {{ report.summary_discounts.buy_return.count }}
                                                </td>
                                                <td class="align-top flex-grow-1">
                                                    {{ $t(`report.buyReturn`) }}
                                                </td>
                                                <td class="flex-shrink-1" align="right">
                                                    {{ report.summary_discounts.buy_return.sum }} &nbsp;&#8376;
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top flex-grow-1" style="width:20%;">
                                                    {{ report.summary_discounts.sell_return.count }}
                                                </td>
                                                <td class="align-top flex-grow-1">
                                                    {{ $t(`report.sellReturn`) }}
                                                </td>
                                                <td class="flex-shrink-1" align="right">
                                                    {{ report.summary_discounts.sell_return.sum }} &nbsp;&#8376;
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                     <table class="w-100 table-sm table-borderless">
                                        <tbody>
                                            <tr>
                                                <td colspan="3"><h4>{{ $t('report.summaryMarkups') }}</h4></td>
                                            </tr>
                                            <tr>
                                                <td class="align-top flex-grow-1" style="width:20%;">
                                                    {{ report.summary_markups.buy.count }}
                                                </td>
                                                <td class="align-top flex-grow-1">
                                                    {{ $t(`report.buy`) }}
                                                </td>
                                                <td class="flex-shrink-1" align="right">
                                                    {{ report.summary_markups.buy.sum }} &nbsp;&#8376;
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top flex-grow-1" style="width:20%;">
                                                    {{ report.summary_markups.sell.count }}
                                                </td>
                                                <td class="align-top flex-grow-1">
                                                    {{ $t(`report.sell`) }}
                                                </td>
                                                <td class="flex-shrink-1" align="right">
                                                    {{ report.summary_markups.sell.sum }} &nbsp;&#8376;
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top flex-grow-1" style="width:20%;">
                                                    {{ report.summary_markups.buy_return.count }}
                                                </td>
                                                <td class="align-top flex-grow-1">
                                                    {{ $t(`report.buyReturn`) }}
                                                </td>
                                                <td class="flex-shrink-1" align="right">
                                                    {{ report.summary_markups.buy_return.sum }} &nbsp;&#8376;
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top flex-grow-1" style="width:20%;">
                                                    {{ report.summary_markups.sell_return.count }}
                                                </td>
                                                <td class="align-top flex-grow-1">
                                                    {{ $t(`report.sellReturn`) }}
                                                </td>
                                                <td class="flex-shrink-1" align="right">
                                                    {{ report.summary_markups.sell_return.sum }} &nbsp;&#8376;
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                             <tr>
                                <td>
                                    <table class="w-100 table-sm table-borderless">
                                        <tbody>
                                            <tr>
                                                <td colspan="3"><h4>{{ $t('report.summaryOperations') }}</h4></td>
                                            </tr>
                                            <tr>
                                                <td class="align-top flex-grow-1" style="width:20%;">
                                                    {{ report.summary_operations.buy.count }}
                                                </td>
                                                <td class="align-top flex-grow-1">
                                                    {{ $t(`report.buy`) }}
                                                </td>
                                                <td class="flex-shrink-1" align="right">
                                                    {{ report.summary_operations.buy.sum }} &nbsp;&#8376;
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top flex-grow-1" style="width:20%;">
                                                    {{ report.summary_operations.sell.count }}
                                                </td>
                                                <td class="align-top flex-grow-1">
                                                    {{ $t(`report.sell`) }}
                                                </td>
                                                <td class="flex-shrink-1" align="right">
                                                    {{ report.summary_operations.sell.sum }} &nbsp;&#8376;
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top flex-grow-1" style="width:20%;">
                                                    {{ report.summary_operations.buy_return.count }}
                                                </td>
                                                <td class="align-top flex-grow-1">
                                                    {{ $t(`report.buyReturn`) }}
                                                </td>
                                                <td class="flex-shrink-1" align="right">
                                                    {{ report.summary_operations.buy_return.sum }} &nbsp;&#8376;
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top flex-grow-1" style="width:20%;">
                                                    {{ report.summary_operations.sell_return.count }}
                                                </td>
                                                <td class="align-top flex-grow-1">
                                                    {{ $t(`report.sellReturn`) }}
                                                </td>
                                                <td class="flex-shrink-1" align="right">
                                                    {{ report.summary_operations.sell_return.sum }} &nbsp;&#8376;
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: 'ZReportDetails',
    props: {
        report: Object
    },
    computed: {
        isV2() {
            return this.report.type === 'FISCAL_PERIOD_REPORT_V2';
        }
    }
}
</script>
